module.exports = __webpack_public_path__ + "static/fonts/AntonSC-Regular.aece98b8.ttf";